import { render } from "./ModalEditParceria.vue?vue&type=template&id=c8d532bc"
import script from "./ModalEditParceria.vue?vue&type=script&lang=js"
export * from "./ModalEditParceria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__